import React, { Component } from 'react';
import { Router, hashHistory, Route } from 'react-router';
import API from './app/api.js';
import Home from './home.js';
import History from './history.js';

class Index extends Component {
  render() {
    return (
      <Router history={hashHistory}>
        <Route path="/" component={Home}/>
        <Route path="/history" component={History}/>
      </Router>
    );
  }
}

export default Index;


// WEBPACK FOOTER //
// ./src/search/index.js